document.addEventListener("DOMContentLoaded", () => {

    // Función para abrir el popup o el video inline
    document.querySelectorAll(".video-popup__trigger").forEach((button) => {
        button.addEventListener("click", function () {
            const videoUrl = this.getAttribute("data-embed");
            if (!videoUrl) return;

            const article = this.closest('.video-popup-block');
            const noPopup = article && article.getAttribute('data-no-popup') === 'true';

            if (noPopup) {
                // Modo inline: ocultar el botón y mostrar el video en el mismo sitio
                this.style.display = 'none';
                
                const embedContainer = article.querySelector('.video-embed-container');
                if (embedContainer) {
                    embedContainer.style.display = 'block';
                    
                    // Añadir parámetros de autoplay para asegurar reproducción automática
                    const autoplayUrl = videoUrl.includes('?') 
                        ? videoUrl + "&autoplay=1&mute=0&rel=0" 
                        : videoUrl + "?autoplay=1&mute=0&rel=0";
                    
                    const iframe = document.createElement("iframe");
                    iframe.setAttribute("src", autoplayUrl);
                    iframe.setAttribute("frameborder", "0");
                    iframe.setAttribute("allowfullscreen", "true");
                    iframe.setAttribute("allow", "autoplay; encrypted-media; picture-in-picture");
                    iframe.setAttribute("playsinline", "true");
                    iframe.style.width = "100%";
                    iframe.style.height = "100%";
                    iframe.style.aspectRatio = "16/9";
                    
                    embedContainer.innerHTML = '';
                    embedContainer.appendChild(iframe);
                }
            } else {
                // Modo popup original
                const overlay = document.createElement("div");
                overlay.classList.add("overlay");
                document.body.appendChild(overlay);

                const popupContainer = document.createElement("div");
                popupContainer.classList.add("overlay__content", "relative");
                overlay.appendChild(popupContainer);

                const closeButton = document.createElement("button");
                closeButton.id = "video-popup-close";
                closeButton.innerHTML = "&times;";
                closeButton.classList.add("video-popup-close");

                popupContainer.appendChild(closeButton);

                const embedContainer = document.createElement("div");
                embedContainer.classList.add("embed-container");

                const iframe = document.createElement("iframe");
                iframe.setAttribute("src", videoUrl + "?autoplay=1&rel=0");
                iframe.setAttribute("frameborder", "0");
                iframe.setAttribute("allowfullscreen", "true");
                iframe.setAttribute("allow", "autoplay; encrypted-media");

                popupContainer.querySelectorAll("iframe").forEach(i => i.remove());

                embedContainer.appendChild(iframe);

                popupContainer.appendChild(embedContainer);

                overlay.classList.add("overlay--opened");

                overlay.addEventListener("click", (e) => {
                    if (e.target === overlay) {
                        overlay.classList.remove("overlay--opened");
                        overlay.removeChild(popupContainer);
                    }
                });

                closeButton.addEventListener("click", () => {
                    overlay.classList.remove("overlay--opened");
                    overlay.removeChild(popupContainer);
                });
            }
        });
    });

});
